import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  ADD_PRIMITIVE_ATTACHMENT_BUTTON: `${cleanedFilename(
    __filename,
  )}-add-primitive-attachment-button`,
};
